<template>
  <div class="home-carousel">

    <div id="carouselExampleIndicatorsMobile" class="carousel slide" data-ride="carousel" data-interval="3000" data-pause="false">
        <ol class="carousel-indicators">
          <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="0" class="active"></li>
          <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="1"></li>
          <li data-target="#carouselExampleIndicatorsMobile" data-slide-to="2"></li>
        </ol>
      <div class="carousel-inner " >
        <div class="carousel-item active"  @click="toPWmatIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_mobile_1.jpeg" alt="First slide">
          <div class="home-carousel-caption  d-md-block">
            <div class="home-carousel-title">即将发布强大功能</div>
            <div class="home-carouse-content">Charge Patching Method<br/>
              Nanostructure Calculation First Principle Device Simulation</div>
            <button class="home-carouse-button home-carouse-button-text">了解更多</button>
          </div>
        </div>
        <div class="carousel-item" @click="toPWmatIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_mobile_2.jpeg" alt="Second slide">
          <div class="home-carousel-caption  d-md-block">
            <div class="home-carousel-title">功能丰富多样</div>
            <div class="home-carouse-content">拥有所有第一性原理软件计算功能</div>
            <button class="home-carouse-button home-carouse-button-text" >了解更多</button>
          </div>
        </div>
        <div class="carousel-item" @click="toPWmatIntroduce">
          <img class="d-block w-100" src="../../assets/home/banner_mobile_3.jpeg" alt="Third slide">
          <div class="home-carousel-caption  d-md-block">
            <div class="home-carousel-title">特色功能应用</div>
            <div class="home-carouse-content">Fast HSE、Electron-Phonon Coupling、rt-TDDFT、NAMD、Solvent Model、材料搜索</div>
            <button class="home-carouse-button home-carouse-button-text">了解更多</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    name: "HomeCarousel",
    mounted() {
      this.$nextTick(() => {
        $('#carouselExampleIndicatorsMobile').carousel({
          interval: 3000,
          pause: false,
        })
      })
    },
    methods:{
      toPWmatIntroduce(){
        this.$router.push({ name: 'PWmatIntroduce'})
      },
    },
    created(){
    }
  }
</script>

<style scoped>
  .home-carousel{
    margin-top: 70px;
  }
  .home-carousel-caption {
    position: absolute;
    right: 15%;
    top: 20%;
    left: 15%;
    z-index: 10;
    color: #fff;
    text-align: center;
  }
  .home-carousel-title{
    font-size: 48px;
    font-family:PingFangSC-Semibold,sans-serif
  }
  .home-carouse-content{
    font-size: 22px;
    font-family: PingFangSC-Light,sans-serif;
    margin-top: 16px;
  }
  .home-carouse-button{
    border: 2px solid #ffffff;
    background-color: rgb(255,255,255,0.2) ;
    margin-top: 50px;
    width: 340px;
    height: 55px;
    cursor: pointer;
  }
  .home-carouse-button:hover,
  .home-carouse-button:active,
  .home-carouse-button:focus{
    box-shadow:none !important;
    outline:none !important;
  }
  .home-carouse-button-text{
    color: #ffffff;
    font-family: PingFangSC-Light,sans-serif;
    font-size: 24px;
  }
  .carousel-item{
    cursor: pointer;
  }
  .carouse-inner-mobile{
    display: none;
  }

  @media (max-width: 470px) {

    .home-carousel-title{
      font-size: 18px;
    }
    .home-carouse-content{
      font-size: 10px;
      margin-top: 10px;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
    .carousel-indicators {
      bottom: 0;
    }
  }

  @media (min-width: 470px) and  (max-width: 576px) {

    .home-carousel-title{
      font-size: 24px;
    }
    .home-carouse-content{
      font-size: 14px;
      margin-top: 10px;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
  }

  @media (min-width: 576px) and  (max-width: 768px) {

    .home-carousel-title{
      font-size: 32px;
    }
    .home-carouse-content{
      font-size: 16px;
    }
    .home-carouse-button{
      display: none;
    }
    .carouse-inner-web{
      display: none;
    }
    .carouse-inner-mobile{
      display: inline;
    }
  }

  @media (min-width: 768px) and  (max-width: 900px) {

    .home-carousel-title{
      font-size: 34px;
    }
    .home-carouse-content{
      font-size: 16px;
    }
    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 900px) and (max-width: 1150px) {

    .home-carousel-title{
      font-size: 40px;
    }
    .home-carouse-content{
      font-size: 18px;
    }
    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 1150px) and (max-width: 1440px) {

    .home-carouse-button{
      display: none;
    }
  }

  @media (min-width: 1440px) {

  }
</style>